import {useMemo} from 'react';
import {Concept} from 'types';
import type {Column} from '../types';
import {useGetAvailableColumnsQuery} from '../advancedSearchApi';
import {mapAvailableColumns} from '../mappers';

type UseAllColumnsResult =
  | {isLoading: true; data: undefined}
  | {isLoading: false; data: Column[]};

/**
 * We first fetch all columns (type=MANIFESTATION is all columns),
 * then we fetch work specific columns, and map them to a boolean
 * in our column definition ("workColumn").
 */
export const useAllColumns = (): UseAllColumnsResult => {
  const {isSuccess: isSuccessAllColumns, data: allColumns} =
    useGetAvailableColumnsQuery(Concept.manifestation);
  const {isSuccess: isSuccessWorkColumns, data: workColumns} =
    useGetAvailableColumnsQuery(Concept.work);

  return useMemo(() => {
    if (!isSuccessAllColumns || !isSuccessWorkColumns) {
      return {
        isLoading: true,
        data: undefined,
      };
    }

    return {
      isLoading: false,
      data: mapAvailableColumns(allColumns ?? [], workColumns ?? []),
    };
  }, [allColumns, isSuccessAllColumns, isSuccessWorkColumns, workColumns]);
};
